import React, { useEffect, useState } from 'react';

const ShowBienes = ({ bienes, canStartAnalysis, onSelectionChange, subastaId, handleCargasUpload }) => {
    const [selectedBienes, setSelectedBienes] = useState(bienes);

    useEffect(() => {
        setSelectedBienes(bienes);
        onSelectionChange(bienes);
    }, [bienes, onSelectionChange]);

    const toggleSelection = (bien) => {
        let updatedSelection;
        // Check if an object with the same id is already in the selection
        const isSelected = selectedBienes.some(selectedBien => selectedBien.num_lote === bien.num_lote);

        if (isSelected) {
            updatedSelection = selectedBienes.filter(selectedBien => selectedBien.num_lote !== bien.num_lote);
        } else {
            updatedSelection = [...selectedBienes, bien];
        }
        setSelectedBienes(updatedSelection);
        onSelectionChange(updatedSelection);
    };

    return (
        <div className='flex flex-col pr-10'>
            <div className="flex flex-col md:flex-row items-center justify-between">
                <div className="flex flex-col items-start">
                    {subastaId && (
                        <h2 className="text-3xl font-bold text-gray-700 py-1 ml-2">
                            {subastaId}
                        </h2>
                    )}
                    <h2 className="text-2xl font-semibold text-gray-700 py-1 ml-2">
                        {`En esta subasta se ejecuta${bienes.length === 1 ? '' : 'n'} ${bienes.length} propiedad${bienes.length === 1 ? '' : 'es'}.`}
                    </h2><p className="text-xl text-gray-600 pb-6 ml-2">Selecciona las que te interesen para obtener un análisis de sus cargas.</p>
                </div>
                {canStartAnalysis && (
                    <button
                        type="button"
                        onClick={handleCargasUpload}
                        className="text-white bg-sky-800 hover:bg-sky-800 font-medium rounded-xl text-xl px-5 py-2.5 me-2 mb-8 md:mb-0 dark:bg-sky-600 dark:hover:bg-sky-700"
                    >
                        Empezar análisis
                        <i className="fas fa-arrow-right ml-2"></i>
                    </button>
                )}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {bienes.map((bien, index) => {
                    const isSelected = selectedBienes.some(selectedBien => selectedBien.num_lote === bien.num_lote);
                    const nombre = bien.nombre || 'Bien sin título';
                    const descripcion = typeof bien.descripcion === 'string' && bien.descripcion.trim()
                        ? bien.descripcion.split('.')[0]
                        : 'Sin descripción disponible';
                    return (
                        <div
                            className={`flex flex-col justify-between bg-white p-4 rounded-lg shadow-md cursor-pointer transition-transform transform hover:scale-105 ${isSelected ? 'border-2 border-sky-500 bg-sky-100' : 'hover:bg-gray-100'}`}
                            key={index}
                            onClick={() => toggleSelection(bien)}
                        >
                            <div>
                                <div className="flex items-start justify-between">
                                    <h2 className="text-lg font-semibold text-gray-700">{`Lote ${bien.num_lote} - ${nombre}`}</h2>
                                    <i className={`fas fa-circle-check ${isSelected ? 'text-sky-500' : 'text-gray-300'}`}></i>
                                </div>
                                <p className="text-sm text-gray-600">{descripcion}</p>
                            </div>
                            <div className="flex items-center justify-between mt-4">
                                <button className="text-sm font-semibold text">{bien.valor ? parseFloat(bien.valor).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }) : 'No consta valor'}</button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ShowBienes;
